<template>
  <span v-if="showSelectActivities">
    <b-col
      v-if="localDataLoad"
      cols="12"
      class="d-flex align-items-center justify-content-center"
    >
      <b-spinner label="Loading..." />
    </b-col>
    <b-row v-if="!localDataLoad">
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Products"
        >
          <multiselect
            v-model="activities_product_ids"
            :options="optionsActivitiesProduct"
            :multiple="true"
            placeholder="Type to search"
            label="text"
            track-by="value"
            @input="$emit('handleActivitiesProduct', activities_product_ids)"
          ><template v-slot:noResult>
            Oops! No elements found. Consider changing the search query.
          </template>
          </multiselect>

        </b-form-group>

      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Sub Products"
        >
          <multiselect
            v-model="activities_ids"
            :options="optionsActivities"
            :multiple="true"
            group-values="options"
            group-label="label"
            :group-select="true"
            placeholder="Type to search"
            track-by="value"
            label="text"
            @input="$emit('handleActivities', activities_ids)"
          ><template v-slot:noResult>
            Oops! No elements found. Consider changing the search query.
          </template>
          </multiselect>

        </b-form-group>
      </b-col>
    </b-row>

  </span>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    showSelectActivities: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activities_product_ids: [],
      activities_ids: [],
      localDataLoad: false,
    }
  },

  computed: {
    optionsActivities() {
      return this.$store.getters['generalData/activities/activitiesSubProducts']
    },
    optionsActivitiesProduct() {
      return this.$store.getters['generalData/activities/activities']
    },
  },
  watch: {
    '$route.query.sub_products': {
      immediate: true,
      handler(newVal) {
        this.activities_ids = this.mapIdsToOptions(newVal) || null
      },
    },
    '$route.query.products': {
      immediate: true,
      handler(newVal) {
        this.activities_product_ids = this.mapIdsToOptionsProduct(newVal) || null
      },
    },
  },

  async mounted() {
    if (this.showSelectActivities) {
      if (!this.$store.getters['generalData/activities/activitiesLoaded']) {
        this.localDataLoad = true
        await this.$store.dispatch('generalData/activities/fetchActivities')
        this.localDataLoad = false
      }
    }
  },
  methods: {
    mapIdsToOptions(idsString) {
      if (!idsString) return []

      const ids = idsString.split(',').map(Number)

      // flatten grouped options
      const flatOptions = this.optionsActivities.flatMap(group => group.options)

      return flatOptions.filter(option => ids.includes(option.value))
    },
    mapIdsToOptionsProduct(idsString) {
      if (!idsString) return []

      const ids = idsString.split(',').map(Number)

      // flatten grouped options
      const flatOptions = this.optionsActivitiesProduct.flatMap(group => group)

      return flatOptions.filter(option => ids.includes(option.value))
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
